import React from "react";
import { Input } from "antd";
export const ProductSerch = (props) => {
  return (
    <Input
      allowClear
      style={{
        width: 350,
      }}
      onChange={({ target: { value } }) => props.searchPoisk(value)}
      type="text"
      placeholder="Qidirish..."
    />
  );
};
